import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      ibes: 'ibeData/ibes'
    })
  }
}
